import {
  addServiceCookie,
  deleteServiceCookie,
  getServicesCookie,
  isServiceExist,
  updateServiceCookie,
} from 'utils/services';
import { dispatchEvent } from 'utils/common';
import { logEvent } from '../helpers';
import { BASKET_EVENT_UPDATE_SERVICE } from '../consts';
import type { BasketSetServiceEventArg, ServiceCookie } from '../../../../../types/services';
import { servicesGuard } from '../../../../../types/guards';

function isBasketSetServicesEvent(e: Event): e is CustomEvent<BasketSetServiceEventArg[]> {
  if (!('detail' in e)) return false;

  if (!Array.isArray(e.detail)) return false;

  if (e.detail.length === 0) return false;

  return e.detail.every(item => servicesGuard(item as ServiceCookie));
}

export const handleBasketSetServices = (e: Event) => {
  if (isBasketSetServicesEvent(e)) {
    logEvent('basket:set_services', e.detail);

    e.detail.forEach(service => {
      if (service.quantity === 0) {
        deleteServiceCookie(service);
      } else if (isServiceExist(service)) {
        updateServiceCookie(service);
      } else {
        addServiceCookie(service);
      }
    });

    const services = getServicesCookie() || [];

    dispatchEvent(BASKET_EVENT_UPDATE_SERVICE, services);
  } else {
    console.error('Invalid arguments in basket:set_services event');
  }
};
